import React from 'react';
import { Helmet } from 'react-helmet';
import Content from '../components/Content/Content';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Quick Flick | Home</title>
      </Helmet>
      <Content />
    </>
  );
};

export default HomePage; 